import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialFlag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.715 21.335h1.52v1.52h-1.52Zm0-15.24h1.52v1.52h-1.52Zm-1.52 12.19h1.52v3.05h-1.52Zm0-10.67h1.52v3.05h-1.52Z\"/><path fill=\"currentColor\" d=\"M19.045 22.855V6.095h10.67v-1.52h-10.67v-1.53h-1.52v16.76H2.285V3.045H.765v27.43h1.52v-9.14h12.19v1.52h1.53v1.52h13.71v-1.52z\"/><path fill=\"currentColor\" d=\"M26.665 15.235h1.53v3.05h-1.53Zm0-4.57h1.53v3.05h-1.53Zm-1.52 3.05h1.52v1.52h-1.52ZM2.285 1.525h15.24v1.52H2.285Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialFlag
